// extracted by mini-css-extract-plugin
export default {"table":"x8ZNBqrUGqf5st9UxQiZ","thead":"SYzbC5_3ZiFYUPkO9d3d","tbody":"L2jotaMJb0eIEQEQ_Jzt","tr":"Z7fn8K1fF3djj5PYtUKZ","td":"tqSGWc2ZgbUJhlFSycJv","th":"qFAQrc5LrrtQCHRhficR"};